import { render, staticRenderFns } from "./LiquidGlassDecor.vue?vue&type=template&id=27e91368&"
import script from "./LiquidGlassDecor.vue?vue&type=script&lang=ts&"
export * from "./LiquidGlassDecor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports